export default __webpack_public_path__ + "static/media/background-main.8f771c8c.svg";